'use strict';

import EcsState from '@/components/ecs-agent-state/EcsState';

const loggedInAgent = state => state.AGENT;

const getLoggedInAgentAvailableLoadAllowances = state => structuredClone(state.availableLoadAllowances);

const currentExtension = state => state.AGENT.currentExtension;

const telephoneTerminals = state => state.telephoneTerminals;

const registrationId = state => state.registrationId;

const isSoftPhoneRegistered = state => state.softPhoneState.isRegistered;

const isRegisteringSoftPhone = state => state.softPhoneState.isRegistering;

const softPhoneRegistrationErrors = state => state.softPhoneState.hasErrors;

const agentState = state => {
  return state.AGENT && state.AGENT.stateId ? new EcsState(state.AGENT) : null;
};

const isWallboard = state => {
  return state.AGENT && state.AGENT.isWallboard;
};

const isSupervisor = state => {
  return state.AGENT && state.AGENT.isSupervisor;
};

const isSupervisorOnly = (state, getters, rootState, rootGetters) => {
  return (
    getters.isSupervisor &&
    rootGetters['STATS/BUSINESS_PROCESSES_STATS'].length === 0 &&
    rootGetters['STATS/SUPERVISED_BUSINESS_PROCESSES_STATS'].length > 0
  );
};

export default {
  loggedInAgent,
  currentExtension,
  telephoneTerminals,
  registrationId,
  isSoftPhoneRegistered,
  isRegisteringSoftPhone,
  softPhoneRegistrationErrors,
  getLoggedInAgentAvailableLoadAllowances,
  agentState,
  isWallboard,
  isSupervisor,
  isSupervisorOnly
};
